import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const items = [
  { key: 'review', icon: 'ri-star-line', to: '/article/usfans-review' },
  { key: 'shipping', icon: 'ri-truck-line', to: '/article/usfans-shipping-cost' },
  { key: 'coupon', icon: 'ri-coupon-2-line', to: '/article/usfans-coupon' },
  { key: 'discount', icon: 'ri-price-tag-3-line', to: '/article/usfans-coupon' },
  { key: 'warehouse', icon: 'ri-building-2-line', to: '/article/usfans-warehouse' },
  { key: 'legit', icon: 'ri-shield-check-line', to: '/article/is-usfans-legit' },
];

export default function SearchSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-cream">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-stone-900 md:text-3xl">
            {t('search.title')}
          </h2>
          <p className="mt-3 text-sm text-stone-500 md:text-base">{t('search.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <Link
              key={item.key}
              to={item.to}
              className="group rounded-lg border border-stone-200 bg-white p-6 transition-colors hover:border-emerald-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-amber-50 text-xl text-amber-600">
                <i className={item.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-stone-900 md:text-lg">
                {t(`search.${item.key}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-stone-500">
                {t(`search.${item.key}.body`)}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-emerald-600 transition-colors group-hover:text-emerald-700">
                {t('cta.readArticle')}
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}